import urlsConfig from 'src/configs/url.config';
import { PermissionEnum } from 'src/enums/permission.enum';

import { UserRoleType, StateType } from 'src/types/redux/user.redux.types';

let permissionsArray: number[] = [];
export const getPermissionKeyByUserRole = (userRoleId: UserRoleType[], userRolePermissionList: any[]): number[] => {
  let genericPermissionList: any[] = [];

  userRoleId.forEach(
    (e: any) =>
      (genericPermissionList = [
        ...genericPermissionList,
        ...userRolePermissionList.filter((obj) => e.id === obj.userRoleId),
      ]),
  );

  permissionsArray = genericPermissionList.reduce((accumulator, currentValue) => {
    if (!accumulator.includes(currentValue.permissionId.toString())) {
      accumulator.push(Number(currentValue.permissionId));
    }
    return accumulator;
  }, [] as number[]);

  return permissionsArray;
};

export const checkPermissionList = (staticId: number): boolean => {
  const checkId = permissionsArray.includes(staticId);

  return !checkId;
};

export const RoutePermissions = {
  ObjectiveManagement: [
    PermissionEnum.ObjectiveCreate,
    PermissionEnum.ObjectiveRead,
    PermissionEnum.ObjectiveUpdate,
    PermissionEnum.ObjectiveDelete,
    PermissionEnum.TOReportRead,
  ],
  FlowManagement: [
    PermissionEnum.IncidentFolderCreate,
    PermissionEnum.IncidentFolderRead,
    PermissionEnum.IncidentFolderUpdate,
    PermissionEnum.IncidentFolderDelete,
    PermissionEnum.IncidentCreate,
    PermissionEnum.IncidentRead,
    PermissionEnum.IncidentUpdate,
    PermissionEnum.IncidentDelete,
    PermissionEnum.ActionCreate,
    PermissionEnum.ActionRead,
    PermissionEnum.ActionUpdate,
    PermissionEnum.ActionDelete,
    PermissionEnum.InjectionCreate,
    PermissionEnum.InjectionRead,
    PermissionEnum.InjectionUpdate,
    PermissionEnum.InjectionDelete,
    PermissionEnum.OutcomeCreate,
    PermissionEnum.OutcomeUpdate,
    PermissionEnum.OutcomeRead,
    PermissionEnum.OutcomeDelete,
    PermissionEnum.ObservationTaskCreate,
    PermissionEnum.ObservationTaskRead,
    PermissionEnum.ObservationTaskUpdate,
    PermissionEnum.ObservationTaskDelete,
    PermissionEnum.StateCreate,
    PermissionEnum.StateUpdate,
    PermissionEnum.StateRead,
    PermissionEnum.StateDelete,
    PermissionEnum.TransactionCreate,
    PermissionEnum.TransactionRead,
    PermissionEnum.TransactionUpdate,
    PermissionEnum.TransactionDelete,
    PermissionEnum.MainIncidentListRead,
    PermissionEnum.TOAndIncidentChartRead,
  ],
  RealLifeSupport: [
    PermissionEnum.ConfigurationChangeRequestCreate,
    PermissionEnum.ConfigurationChangeRequestUpdate,
    PermissionEnum.ConfigurationChangeRequestRead,
    PermissionEnum.ConfigurationChangeRequestDelete,
    PermissionEnum.TroubleTicketRead,
    PermissionEnum.TroubleTicketUpdate,
    PermissionEnum.TroubleTicketCreate,
    PermissionEnum.TroubleTicketDelete,
    PermissionEnum.RegistryCreate,
    PermissionEnum.RegistryRead,
    PermissionEnum.RegistryUpdate,
    PermissionEnum.RegistryDelete,
    PermissionEnum.TechnicalSupportRequestCreate,
    PermissionEnum.TechnicalSupportRequestRead,
    PermissionEnum.TechnicalSupportRequestUpdate,
    PermissionEnum.TechnicalSupportRequestDelete,
  ],
  Experimentation: [PermissionEnum.ExperimentationRead],
  Lill: [
    PermissionEnum.LillCreate,
    PermissionEnum.LillRead,
    PermissionEnum.LillDelete,
    PermissionEnum.LillUpdate,
    PermissionEnum.LillObserverUpdate,
    PermissionEnum.LillProprietorUpdate,
    PermissionEnum.LillAnalystUpdate,
    PermissionEnum.LillTaskingAuthorityUpdate,
    PermissionEnum.LillActionBodyUpdate,
  ],

  SSM: [
    PermissionEnum.GeostrategicSituationRead,
    PermissionEnum.RoadToCurrentSettingRead,
    PermissionEnum.ActorBooksRead,
  ],
  Administration: [
    PermissionEnum.EventCreate,
    PermissionEnum.EventDelete,
    PermissionEnum.EventUpdate,
    PermissionEnum.EventRead,
    PermissionEnum.OntologiesCreate,
    PermissionEnum.OntologiesUpdate,
    PermissionEnum.OntologiesRead,
    PermissionEnum.OntologiesDelete,
    PermissionEnum.UserRightsCreate,
    PermissionEnum.UserRightsDelete,
    PermissionEnum.UserRightsUpdate,
    PermissionEnum.UserRightsRead,
    PermissionEnum.UserCreate,
    PermissionEnum.UserUpdate,
    PermissionEnum.UserDelete,
    PermissionEnum.UserRead,
    PermissionEnum.SettingCreate,
    PermissionEnum.SettingDelete,
    PermissionEnum.SettingUpdate,
    PermissionEnum.SettingRead,
  ],
};

export const checkRoutePermissions = (userPermissions: any[]): string => {
  let result = '';
  let admin = false;
  let isRLSMEnabled = false;

  userPermissions.forEach((roleId) => {
    Object.entries(RoutePermissions).forEach((obj) => {
      if (obj[1].includes(roleId) && roleId.toString().endsWith('1')) {
        result = obj[0];
        if (result === 'Administration') {
          admin = true;
        }
      } else if (result === 'RealLifeSupport' && urlsConfig.officeConfig) {
        isRLSMEnabled = true;
      }
    });
  });

  if (isRLSMEnabled) {
    return 'RealLifeSupport';
  }

  return admin ? 'Administration' : result;
};

export const checkRLSMUpdatePermission = (
  userState: StateType,
  enumType: any,
  record: any,
  editModal: boolean,
): boolean => {
  if (!editModal) return false;
  let flag: boolean = false;
  if (!checkPermissionList(enumType)) flag = true;
  else if (userState.id === record.taskedToId || userState.id === record.createdById) flag = true;
  else flag = false;

  return !flag;
};

// export const checkUpdateFieldsPermission = (setEditModal: boolean, userId: string | undefined, record: any) => {
//   if (!setEditModal) {
//     return false;
//   }
//   if (userId) {
//     if (userId === record.createdById) return false;
//     return true;
//   }
//   return true;
// };

// export const checkUpdateStatusPermission = (
//   addCCRModal: boolean,
//   userState: StateType,
//   eventId: string,
//   record: any,
// ) => {
//   if (addCCRModal) return true;
//   else if (userState.userName === record.taskedToId) return false;
//   else if (userState.events.find((e) => e.id === eventId)?.roles.some((r) => r.abbreviation === 'Tasking Auth'))
//     return false;
//   else return true;
// };
